import { Api } from "../../api";

/**
 * Получает отзывы и вопросы для одного товара.
 * @param {string|number} productId - id товара
 * @param {boolean} isReset - сброс кэша
 * @param {'server'|'client'} source - server: только Redis, client: полный flow
 */
export const fetchProductReviewsAndQuestionsById = (
  productId,
  host = "",
  isReset = false,
  source = "client",
) => {
  return async (dispatch, getState) => {
    const { data } = getState().reviewsAndQuestions || {};

    if (data?.[productId] && !isReset) {
      return;
    }

    const hostName = getState().params?.host || host;

    const response = await Api.server.getProductReviewsAndQuestionsByIds(
      [productId],
      hostName,
      isReset,
      source,
    );

    if (response && Object.keys(response).length > 0) {
      const mergedData = { ...data, ...response };
      dispatch({
        type: "FETCH_REVIEWS_AND_QUESTIONS_BY_IDS",
        payload: mergedData,
      });
    }
  };
};
